export const SWITCHER_ICON_CLASS =
  "size-9 hover:bg-secondary-hover focus:bg-secondary-hover !m-0 flex items-center justify-center rounded-lg border border-transparent transition-colors duration-150";
